export default __webpack_public_path__ + "static/media/Xenia21_Text.1fe0be87.png";